module.exports = __webpack_public_path__ + "d4b2274ecbd8d845056bd5f6f870663d.png";